import { useContext } from 'react'
import { MobXProviderContext } from 'mobx-react'
import type { OptionAdvertisementBlocksStore } from '../stores/optionAdvertisementBlocks.store'
import type { OptionsStore } from '../stores/options.store'
import type { PlansStore } from '../stores/plans.store'
import type { SellerStore } from '../stores/seller.store'
import type { PublisherStore } from '../stores/publisher.store'
import type { EloPublisherStore } from '../stores/eloPublisher.store'
import type { TeamMemberStore } from '../stores/teamMember.store'
import type { SalesTeamMemberStore } from '../stores/salesTeamMember.store'
import type { PayerStore } from '../stores/payer.store'
import type { TrackingLogsStore } from '../stores/trackingLogs.store'
import type { UserStore } from '../stores/user.store'
import type { UserProfilesStore } from '../stores/userProfiles.store'
import type { CountriesStore } from '../stores/countries.store'
import type { AudioPlayersStore } from '../stores/audioPlayers.store'
import type { VatUserRegistrationsStore } from '../stores/vatUserRegistrations.store'
import type { VatCheckerStore } from '../stores/vatChecker.store'
import type { CurrenciesStore } from '../stores/currencies.store'
import type { TableFiltersStore } from '../stores/tableFilters.store'
import type { BookingStore } from '../stores/booking.store'
import type { UserVerificationStore } from '../stores/userVerification.store'
import type { OnboardingJourneyStore } from '../stores/onboardingJourney.store'
import type { LegalEntityStore } from '../stores/legalEntity.store'
import type { AccountStore } from '../stores/account.store'
import type { CountriesV2Store } from '../stores/countriesV2.store'
import type { ExperimentsStore } from '../stores/experiments.store'
import type { NaturalPersonsEntityStore } from '../stores/naturalPersonsEntity.store'
import type { CompaniesEntityStore } from '../stores/companiesEntity.store'
import type { NaturalPersonsVatRegistrationsStore } from '../stores/naturalPersonsVatRegistrations.store'
import type { CompaniesVatRegistrationsStore } from '../stores/companiesVatRegistrations.store'
import type { BankAccountConfigStore } from '../stores/bankAccountConfig.store'
import type { BankAccountsStore } from '../stores/bankAccounts.store'
import type { PartnerStore } from '../stores/partner.store'
import type { NotificTypesStore } from '../stores/notificTypes.store'
import type { NotificTypesProfilesStore } from '../stores/notificTypesProfiles.store'
import type { SalesTeamMemberNotificationsV2Store } from '../stores/salesTeamMemberNotificationsV2.store'

interface SharedStores {
  optionAdvertisementBlocksStore: OptionAdvertisementBlocksStore
  optionsStore: OptionsStore
  plansStore: PlansStore
  sellerStore: SellerStore
  publisherStore: PublisherStore
  eloPublisherStore: EloPublisherStore
  teamMemberStore: TeamMemberStore
  salesTeamMemberStore: SalesTeamMemberStore
  payerStore: PayerStore
  trackingLogsStore: TrackingLogsStore
  userStore: UserStore
  userProfilesStore: UserProfilesStore
  countriesStore: CountriesStore
  audioPlayersStore: AudioPlayersStore
  vatUserRegistrationsStore: VatUserRegistrationsStore
  vatCheckerStore: VatCheckerStore
  currenciesStore: CurrenciesStore
  tableFiltersStore: TableFiltersStore
  bookingStore: BookingStore
  userVerificationStore: UserVerificationStore
  onboardingJourneyStore: OnboardingJourneyStore
  legalEntityStore: LegalEntityStore
  accountStore: AccountStore
  countriesV2Store: CountriesV2Store
  experimentsStore: ExperimentsStore
  naturalPersonsEntityStore: NaturalPersonsEntityStore
  companiesEntityStore: CompaniesEntityStore
  naturalPersonsVatRegistrationsStore: NaturalPersonsVatRegistrationsStore
  companiesVatRegistrationsStore: CompaniesVatRegistrationsStore
  bankAccountConfigStore: BankAccountConfigStore
  bankAccountsStore: BankAccountsStore
  partnerStore: PartnerStore
  notificTypesStore: NotificTypesStore
  notificTypesProfilesStore: NotificTypesProfilesStore
  salesTeamMemberNotificationsV2Store: SalesTeamMemberNotificationsV2Store
}

export const useSharedStores = () => useContext(MobXProviderContext) as unknown as SharedStores
